export enum RememberType {
  LocalStorage,
  SessionStorage,
  DontPersist,
}
